export const formatImageUrl = (url) => {
    if (!url) return '';
    
    if (
        url.includes('127.0.0.1:9000') || 
        url.includes('localhost:9000') || 
        url.includes('amazonaws.com') ||
        url.includes('minio') ||
        url.includes('/construction-photos/') || 
        url.includes('/archi-assets/') ||
        url.includes('cam7-') ||
        url.includes('cam9-') ||
        url.includes('timelapse-') ||
        url.includes('blueprint-')
    ) {
        const filename = url.split('/').pop().split('?')[0];
        const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        
        if (isLocal) {
            return `http://localhost:4000/api/media/file/${filename}`;
        } else {
            return `/api/media/file/${filename}`;
        }
    }
    
    return url;
};

